const FormatDate = (date) => {
  if (!(date instanceof Date)) {
    throw new Error("Input must be a Date object");
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1; // Months are zero-indexed
  const day = date.getDate();

  return `${year}-${month}-${day}`;
};

export default FormatDate;
